import firebase from "firebase";

export default {
	getDate: () => {
		return firebase.firestore.Timestamp.fromDate(new Date());
	},
	getAuth: (state) => {
		return state.auth;
	},
	getUser: (state) => {
		return state.user;
	}, 
	getColors:( state ) =>{
		return state.colors
	}
}